/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
 */
export interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    content_type?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    filesize_in_bytes?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    page_count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    s3_access_url?: string;
    /**
     * 
     * @type {CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    external_ehr_document?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner
     */
    combined_from_lead_id?: string;
}

/**
 * Check if a given object implements the CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner interface.
 */
export function instanceOfCreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON(json: any): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner {
    return CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': json['s3_key'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'filesize_in_bytes': !exists(json, 'filesize_in_bytes') ? undefined : json['filesize_in_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': !exists(json, 'combined_from_lead_id') ? undefined : json['combined_from_lead_id'],
    };
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON(value?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'created_at': value.created_at,
        'content_type': value.content_type,
        'filesize_in_bytes': value.filesize_in_bytes,
        'page_count': value.page_count,
        's3_access_url': value.s3_access_url,
        'external_ehr_document': CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value.external_ehr_document),
        'combined_from_lead_id': value.combined_from_lead_id,
    };
}

